import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Bar, Pie } from "react-chartjs-2";
import { useEffect, useState } from "react";
import { MenuItem, Menu } from "semantic-ui-react";
import { getAniosDisponibles, getEstadoServiciosPorAnio, getEstadoServiciosPorMesYAnio } from "./serviceLizen";
import { BACKGROUND_COLOR_PLUGIN } from "./../shared/utils";
import TituloYDescarga from "../shared/components/TituloYDescarga";

ChartJS.register(ArcElement, Tooltip, Legend);

const ServicioLizenEstado = () => {
  
  const CHART_ID_PIE = 'servicios_lizen_estado_pie';
  const CHART_ID_BAR = 'servicios_lizen_estado_bar';
  const CHART_TITLE = 'Estado de los servicios';

  const [dataSet, setDataSet] = useState(null);
  const [dataSetBar, setDataSetBar] = useState(null);
  const [activeItem, setActiveItem] = useState(new Date().getFullYear());
  const [aniosDisponibles, setAniosDisponibles] = useState([
    new Date().getFullYear(),
  ]);

  const handleItemClick = (e, { name }) => setActiveItem(name);

  useEffect(() => {
    async function fetchData() {
      setAniosDisponibles(await getAniosDisponibles());
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setDataSet(await getEstadoServiciosPorAnio(activeItem));
      setDataSetBar(await getEstadoServiciosPorMesYAnio(activeItem));
    }

    fetchData();
  }, [activeItem]);

  return dataSet && dataSetBar ? (
    <div>
      <TituloYDescarga titulo={CHART_TITLE} idsCharts={[CHART_ID_PIE, CHART_ID_BAR]} chartsNames={[CHART_ID_PIE, CHART_ID_BAR]}/>
      <Menu attached="top" tabular>
        {aniosDisponibles &&
          aniosDisponibles.map((anio) => (
            <MenuItem
              name={anio}
              active={activeItem === anio}
              onClick={handleItemClick}
            />
          ))}
      </Menu>{" "}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div>
          <Pie id={CHART_ID_PIE} plugins={[BACKGROUND_COLOR_PLUGIN]} width={250} data={dataSet} />
        </div>
        <div style={{ width: "100%" }}>
          <Bar id={CHART_ID_BAR} plugins={[BACKGROUND_COLOR_PLUGIN]} height={100} data={dataSetBar} />
        </div>
      </div>
    </div>
  ) : (
    <div>Cargando...</div>
  );
};
export default ServicioLizenEstado;
